function dispatchCustomEvent(eventName, detail = {}) {
  const event = new CustomEvent(eventName, {
    detail,
    bubbles: true
  });
  document.dispatchEvent(event);
}

// Manejador de eventos global para cerrar el selector al hacer clic fuera
// Inicializamos la variable global
window.activeQuickBuyCard = null;

// Función para cerrar el selector de tallas activo
function closeActiveQuickBuy() {
  
  // Cerrar todos los selectores abiertos (independientemente de activeQuickBuyCard)
  const openSections = document.querySelectorAll('.wim-quickbuy-section[style*="bottom: 0"]');
  
  openSections.forEach(section => {
    section.style.bottom = "-100%";
    section.style.pointerEvents = "none";
    section.style.zIndex = ""; // Restablecer z-index
  });
  
  // Si hay una tarjeta activa, restablecer su estado
  if (window.activeQuickBuyCard) {
    // Restaurar estado visual
    window.activeQuickBuyCard.classList.remove('show-quickbuy');
    window.activeQuickBuyCard.classList.remove('show-secondary-image');
    
    // Restaurar imagen primaria
    const primaryImage = window.activeQuickBuyCard.querySelector(".product-card__image--primary");
    const secondaryImage = window.activeQuickBuyCard.querySelector(".product-card__image--secondary");
    
    if (primaryImage && secondaryImage) {
      primaryImage.style.opacity = "1";
      secondaryImage.style.opacity = "0";
    }
    
    // Mostrar botón +
    const quickAddButton = window.activeQuickBuyCard.querySelector(".product-card__quick-add-button");
    if (quickAddButton) {
      quickAddButton.style.display = "block";
      quickAddButton.style.opacity = "1";
      quickAddButton.style.visibility = "visible";
    }
    
    // Limpiar referencia
    window.activeQuickBuyCard = null;
  }
  
  // Restaurar todos los botones "+" que puedan haberse ocultado
  document.querySelectorAll('.product-card__quick-add-button[style*="display: none"]').forEach(button => {
    button.style.display = "block";
    button.style.opacity = "1";
    button.style.visibility = "visible";
  });
  
  // Eliminar clase del body
  document.body.classList.remove('quickbuy-open');
}

// Cerrar al hacer click fuera del popup (en el overlay)
document.addEventListener("click", function(e) {
  // Comprobar si hay un selector activo y si el body tiene la clase 'quickbuy-open'
  if (window.activeQuickBuyCard && document.body.classList.contains('quickbuy-open')) {
    // Detectar si el clic fue en el overlay
    const overlay = document.querySelector('body.quickbuy-open');
    const isOverlayClick = e.target === overlay || e.target === document.body;
    
    // Detectar si el clic fue dentro del selector de tallas
    const openSelector = document.querySelector('.wim-quickbuy-section[style*="bottom: 0"]');
    const isWithinSelector = openSelector && openSelector.contains(e.target);
    
    // Detectar si es un botón +
    const isQuickButton = e.target.classList.contains('product-card__quick-add-button');
    
    
    // Si el clic fue en el overlay pero NO dentro del selector, cerrar
    if ((isOverlayClick || !isWithinSelector) && !isQuickButton) {
      e.preventDefault();
      e.stopPropagation();
      closeActiveQuickBuy();
    }
  }
});

// Añadir soporte para cerrar deslizando hacia abajo en móviles
if (window.innerWidth < 768) {
  let touchStartY = 0;
  let touchEndY = 0;
  
  document.addEventListener('touchstart', function(e) {
    if (window.activeQuickBuyCard) {
      const sizesContainer = document.querySelector('.wim-quickbuy-section[style*="bottom: 0"]');
      if (sizesContainer && sizesContainer.contains(e.target)) {
        touchStartY = e.touches[0].clientY;
      }
    }
  }, false);
  
  document.addEventListener('touchmove', function(e) {
    if (window.activeQuickBuyCard && touchStartY > 0) {
      touchEndY = e.touches[0].clientY;
    }
  }, false);
  
  document.addEventListener('touchend', function(e) {
    if (window.activeQuickBuyCard && touchStartY > 0) {
      // Si deslizó hacia abajo más de 50px
      if (touchEndY - touchStartY > 50) {
        closeActiveQuickBuy();
      }
      
      // Reiniciar valores
      touchStartY = 0;
      touchEndY = 0;
    }
  }, false);
}

// Inicializar al cargar
document.addEventListener('DOMContentLoaded', function() {
  // Crear un div independiente para el overlay
  const overlayDiv = document.createElement('div');
  overlayDiv.className = 'wim-quickbuy-overlay';
  overlayDiv.style.position = 'fixed';
  overlayDiv.style.top = '0';
  overlayDiv.style.left = '0';
  overlayDiv.style.right = '0';
  overlayDiv.style.bottom = '0';
  overlayDiv.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
  overlayDiv.style.zIndex = '15000';
  overlayDiv.style.display = 'none';
  overlayDiv.style.opacity = '0';
  overlayDiv.style.transition = 'opacity 0.3s ease';
  document.body.appendChild(overlayDiv);
  
  // Añadir manejador de eventos de clic al overlay
  overlayDiv.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    closeActiveQuickBuy();
  });
  
  // Modificar las funciones existentes para mostrar/ocultar el overlay
  const originalCloseFunction = closeActiveQuickBuy;
  closeActiveQuickBuy = function() {
    originalCloseFunction();
    overlayDiv.style.display = 'none';
    overlayDiv.style.opacity = '0';
  };
  
  // Inicializar Quick Buy
  initializeQuickBuy();
  
  // Reinicializar cuando cambie el contenido de la página (para cargas AJAX)
  const observer = new MutationObserver(function(mutationsList) {
    let shouldReinitialize = false;
    
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // Comprobar si se ha añadido algún elemento relevante antes de reinicializar
        for (let node of mutation.addedNodes) {
          if (node.nodeType === 1) { // Solo elementos HTML
            if (node.classList && 
                (node.classList.contains('product-card') || 
                 node.querySelector('.product-card') || 
                 node.querySelector('.wim-quickbuy-section') || 
                 node.querySelector('.product-card__quick-add-button'))) {
              shouldReinitialize = true;
              break;
            }
          }
        }
      }
    }
    
    if (shouldReinitialize) {
      initializeQuickBuy();
    }
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
});

// Función para mover las secciones al body
function moveQuickBuySectionsToBody() {
  if (window.innerWidth < 768) {
    const quickBuySections = document.querySelectorAll(".wim-quickbuy-section:not([data-moved-to-body])");
    
    quickBuySections.forEach(section => {
      // Guardar referencia a la product card original y al figure
      const originalProductCard = section.closest('.product-card');
      const originalFigure = section.closest('.product-card__figure');
      
      if (originalProductCard) {
        
        // Obtener identificadores del producto
        const productHandle = originalProductCard.getAttribute('handle') || 
                            originalProductCard.querySelector('[data-handle]')?.getAttribute('data-handle') ||
                            originalProductCard.dataset.productHandle;
                            
        const productId = originalProductCard.dataset.productId || 
                         originalProductCard.getAttribute('data-product-id') || 
                         originalProductCard.querySelector('[data-product-id]')?.getAttribute('data-product-id');
        
        // Crear atributos de datos para rastrear la product card y el figure original
        if (productHandle) {
          section.setAttribute('data-original-product-card', productHandle);
        }
        
        if (productId) {
          section.setAttribute('data-original-product-id', productId);
        }

        // Guardar referencia al figure original
        if (originalFigure) {
          section.setAttribute('data-original-figure', 'product-card__figure');
        }
        
        // Mover el selector al final del body
        document.body.appendChild(section);
        
        // Reiniciar los estilos para asegurar que está oculto correctamente
        section.style.bottom = "-100%";
        section.style.opacity = "1";
        section.style.display = "block";
        section.style.visibility = "visible";
        section.style.pointerEvents = "none";
        
        // Marcar como movido
        section.setAttribute('data-moved-to-body', 'true');
      }
    });
  } else {
    // En desktop, devolver las secciones a sus product cards originales
    const movedSections = document.querySelectorAll(".wim-quickbuy-section[data-moved-to-body]");
    
    movedSections.forEach(section => {
      const productHandle = section.getAttribute('data-original-product-card');
      if (productHandle) {
        const originalCard = document.querySelector(`.product-card[handle="${productHandle}"]`) ||
                           document.querySelector(`.product-card [data-handle="${productHandle}"]`)?.closest('.product-card');
        
        if (originalCard) {
          // Buscar específicamente el product-card__figure
          const targetFigure = originalCard.querySelector('.product-card__figure');
          
          if (targetFigure) {
            // Insertar dentro del figure
            targetFigure.appendChild(section);
          } else {
            console.warn('No se encontró .product-card__figure, buscando alternativas...');
            // Intentar encontrar otros elementos figure como fallback
            const fallbackFigure = originalCard.querySelector('figure');
            if (fallbackFigure) {
              fallbackFigure.appendChild(section);
            } else {
              // Si no hay figure, insertar en el product card como último recurso
              originalCard.appendChild(section);
              console.warn('No se encontró ningún figure, insertando en product card');
            }
          }
          
          section.removeAttribute('data-moved-to-body');
          
          // Restablecer estilos para desktop
          section.style.position = "absolute";
          section.style.bottom = "0";
          section.style.opacity = "0";
          section.style.display = "block";
          section.style.visibility = "visible";
        }
      }
    });
  }
}

// Manejar el redimensionamiento de la ventana
let resizeTimeout;
window.addEventListener('resize', function() {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(function() {
    moveQuickBuySectionsToBody();
  }, 250); // Esperar 250ms después del último evento de resize
});

// Modificar la función initializeQuickBuy para usar la nueva función
function initializeQuickBuy() {
  
  // Primero, cerrar cualquier selector que pudiera estar abierto
  closeActiveQuickBuy();
  
  // Mover las secciones según el tamaño de pantalla actual
  moveQuickBuySectionsToBody();
  
  // Inicializar botones de tallas
  const cartAdds = document.querySelectorAll(".wim-sizes-box:not([data-quickbuy-initialized])");

  // Inicializar tarjetas de producto
  const productCards = document.querySelectorAll(".product-card:not([data-quickbuy-initialized])");

  // Inicializar botones + en móviles
  const quickButtons = document.querySelectorAll(".product-card__quick-add-button:not([data-quickbuy-initialized])");

  // Limpiar cualquier atributo data-moved-to-body incorrecto
  document.querySelectorAll(".wim-quickbuy-section[data-moved-to-body]:not(body > .wim-quickbuy-section)").forEach(section => {
    section.removeAttribute('data-moved-to-body');
  });

  // Agregar título al selector de tallas si no existe
  const sizesContainers = document.querySelectorAll(".wim-quickbuy-section:not([data-title-added])");
  sizesContainers.forEach(container => {
    // Crear un contenedor para el encabezado que incluya el título y el botón de cierre
    if (!container.querySelector('.wim-sizes-head')) {
      const headerContainer = document.createElement('div');
      headerContainer.className = 'wim-sizes-header';
      headerContainer.style.display = 'flex';
      headerContainer.style.justifyContent = 'space-between';
      headerContainer.style.alignItems = 'center';
      headerContainer.style.width = '100%';
      headerContainer.style.padding = '0 15px';
      headerContainer.style.marginBottom = '15px';
      
      // Crear el título — J10: locale-aware label
      const titleElement = document.createElement('div');
      titleElement.className = 'wim-sizes-head';
      {
        const _lang = (document.documentElement.lang || 'es').toLowerCase();
        if (_lang.startsWith('en')) {
          titleElement.textContent = 'SELECT YOUR SIZE';
        } else if (_lang.startsWith('it')) {
          titleElement.textContent = 'SELEZIONA LA TUA TAGLIA';
        } else {
          titleElement.textContent = 'SELECCIONA TU TALLA';
        }
      }
      titleElement.style.margin = '0';
      titleElement.style.padding = '15px 0';
      titleElement.style.border = 'none';
      
      // Crear el botón de cierre
      const closeButton = document.createElement('button');
      closeButton.className = 'wim-quickbuy-close';
      closeButton.innerHTML = '✕'; // Símbolo X
      closeButton.style.background = 'transparent';
      closeButton.style.border = 'none';
      closeButton.style.fontSize = '20px';
      closeButton.style.cursor = 'pointer';
      closeButton.style.padding = '0 10px';
      closeButton.style.color = '#000';
      
      // Agregar evento de cierre
      closeButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeActiveQuickBuy();
      });
      
      // Agregar elementos al contenedor de encabezado
      headerContainer.appendChild(titleElement);
      headerContainer.appendChild(closeButton);
      
      // Insertar al principio del contenedor
      if (container.firstChild) {
        container.insertBefore(headerContainer, container.firstChild);
      } else {
        container.appendChild(headerContainer);
      }
    }
    
    container.setAttribute("data-title-added", "true");
  });

  if (cartAdds) {
    cartAdds.forEach((cartAdd) => {
      cartAdd.addEventListener("click", (e) => {
        // Prevenir clicks en tallas no disponibles
        if (cartAdd.classList.contains('wim-disabled')) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        
        const variantId = cartAdd.querySelector(".wim-sizes-title").getAttribute("data-cart-add-custom");
        if (variantId) {
          
          // Añadir clase para indicar visualmente
          cartAdd.classList.add("adding-to-cart");
          
          // Remover la clase después de un tiempo
          setTimeout(() => {
            cartAdd.classList.remove("adding-to-cart");
          }, 1000);
          
          // Cerrar el popup después de añadir al carrito
          closeActiveQuickBuy();
          
          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              items: [
                {
                  id: parseInt(variantId),
                  quantity: 1,
                },
              ],
            }),
          })
            .then((response) => response.json())
            .then((data) => {
              if (data) {
                const cartDrawer = document.querySelector("cart-drawer");
                if (cartDrawer) {
                  // Disparar evento de actualización del carrito
                  dispatchCustomEvent('cart:refresh');
                  // Disparar evento nativo de Shopify
                  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true
                  }));
                  // Intentar actualizar el carrito usando los métodos nativos
                  if (typeof cartDrawer.refreshCart === 'function') {
                    cartDrawer.refreshCart();
                  }
                  cartDrawer.show();
                }
              }
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        } else {
          console.error('No se encontró el ID de variante');
        }
      }, { passive: false, capture: true }); // Usar capture para asegurar que este evento se dispare primero
      
      cartAdd.setAttribute("data-quickbuy-initialized", "true");
    });
  }

  if (productCards) {
    productCards.forEach((card) => {
      // En desktop, mostrar/ocultar con hover
      if (window.innerWidth >= 768) {
        card.addEventListener("mouseover", () => {
          const sizesContainer = card.querySelector(".wim-quickbuy-section");
          if (sizesContainer) {
            sizesContainer.style.opacity = "1";
            sizesContainer.style.pointerEvents = "auto";
          }
        });
  
        card.addEventListener("mouseout", () => {
          const sizesContainer = card.querySelector(".wim-quickbuy-section");
          if (sizesContainer) {
            sizesContainer.style.opacity = "0";
          }
        });
      }

      card.setAttribute("data-quickbuy-initialized", "true");
    });
  }

  // Manejar los botones + en móviles
  if (quickButtons) {
    quickButtons.forEach((button) => {
      button.addEventListener("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const productCard = this.closest(".product-card");
        
        // Cerrar TODOS los selectores abiertos, no solo si hay uno activo
        closeActiveQuickBuy();
        
        // Limpiar cualquier selector que pueda estar abierto
        document.querySelectorAll('.wim-quickbuy-section[style*="bottom: 0"]').forEach(section => {
          section.style.bottom = "-100%";
          section.style.pointerEvents = "none";
        });
        
        document.body.classList.remove('quickbuy-open');
        
        // Verificar si la product card tiene un handle
        const productHandle = productCard.getAttribute('handle') || 
                             productCard.querySelector('[data-handle]')?.getAttribute('data-handle') ||
                             productCard.dataset.productHandle ||
                             productCard.id;
        
        
        // Buscar el contenedor de tallas (que ahora está en el body)
        let sizesContainer = null;
        
        if (window.innerWidth < 768) {
          if (productHandle) {
            // Buscar por el handle del producto
            sizesContainer = document.querySelector(`.wim-quickbuy-section[data-original-product-card="${productHandle}"]`);
          }
          
          // Si no encontramos por handle, buscar todos los contenedores movidos
          if (!sizesContainer) {
            
            // Buscar por ID del producto si está disponible
            const productId = productCard.dataset.productId || 
                             productCard.getAttribute('data-product-id') || 
                             productCard.querySelector('[data-product-id]')?.getAttribute('data-product-id');
            
            if (productId) {
              sizesContainer = document.querySelector(`.wim-quickbuy-section[data-original-product-id="${productId}"]`);
            }
            
            // Si aún no encontramos, buscar cualquier selector que no esté asignado
            if (!sizesContainer) {
              const allContainers = document.querySelectorAll('.wim-quickbuy-section[data-moved-to-body="true"]');
              // Intentar encontrar el contenedor que no esté actualmente asignado a ninguna tarjeta
              for (const container of allContainers) {
                const originalCard = container.getAttribute('data-original-product-card');
                if (!originalCard || originalCard === "") {
                  sizesContainer = container;
                  break;
                }
              }
              
              // Como último recurso, usar el primer contenedor disponible
              if (!sizesContainer && allContainers.length > 0) {
                sizesContainer = allContainers[0];
              }
            }
          }
        } else {
          // En desktop, buscar dentro de la tarjeta
          sizesContainer = productCard.querySelector(".wim-quickbuy-section");
        }
        
        
        if (sizesContainer) {
          // Esconder cualquier otro contenedor de tallas que pueda estar visible
          document.querySelectorAll('.wim-quickbuy-section').forEach(section => {
            if (section !== sizesContainer) {
              section.style.bottom = "-100%";
              section.style.opacity = "0";
              section.style.pointerEvents = "none";
            }
          });
          
          // Mostrar el selector de tallas
          productCard.classList.add('show-quickbuy');
          document.body.classList.add('quickbuy-open'); // Añadir clase para mostrar el overlay
          
          // Asegurarnos que el contenedor esté visible
          sizesContainer.style.opacity = "1";
          sizesContainer.style.bottom = "0";
          sizesContainer.style.pointerEvents = "auto";
          sizesContainer.style.visibility = "visible";
          sizesContainer.style.display = "block";
          sizesContainer.style.zIndex = "20000"; // Asegurar que el z-index sea muy alto
          
          // Mostrar el overlay independiente
          const overlayDiv = document.querySelector('.wim-quickbuy-overlay');
          if (overlayDiv) {
            overlayDiv.style.display = 'block';
            setTimeout(function() {
              overlayDiv.style.opacity = '1';
            }, 10);
          }
          
          // Si encontramos el contenedor pero no tiene asignado un handle, lo asignamos ahora
          if (productHandle && (!sizesContainer.getAttribute('data-original-product-card') || sizesContainer.getAttribute('data-original-product-card') === "")) {
            sizesContainer.setAttribute('data-original-product-card', productHandle);
          }
          
          // También cambiamos a la imagen secundaria
          productCard.classList.add('show-secondary-image');
          
          const primaryImage = productCard.querySelector(".product-card__image--primary");
          const secondaryImage = productCard.querySelector(".product-card__image--secondary");
          
          if (primaryImage && secondaryImage) {
            primaryImage.style.opacity = "0";
            secondaryImage.style.opacity = "1";
          }
          
          // Ocultar el botón +
          this.style.display = "none";
          this.style.opacity = "0";
          this.style.visibility = "hidden";
          
          // Guardar referencia global a la tarjeta activa
          window.activeQuickBuyCard = productCard;
        } else {
          console.error('No se encontró el contenedor de tallas wim-quickbuy-section');
          // En caso de error, mostrar un mensaje en la consola con información de debug
        }
      });
      
      button.setAttribute("data-quickbuy-initialized", "true");
    });
  }
}

// También inicializar cuando cambia la página
document.addEventListener('pagination:page-changed', () => {
  initializeQuickBuy();
});

// Inicializar en caso de cargas dinámicas de contenido
document.addEventListener('shopify:section:load', () => {
  initializeQuickBuy();
});

// Inicializar después de completar la carga de la página
window.addEventListener('load', () => {
  initializeQuickBuy();
  
  // Depuración para ver si los selectores están presentes
  setTimeout(function() {
    const allSections = document.querySelectorAll('.wim-quickbuy-section');
    
    // Verificar botones + inicializados
    const initializedButtons = document.querySelectorAll('.product-card__quick-add-button[data-quickbuy-initialized]');
  }, 1000);
});

// Exponer funciones para debugging en caso necesario
window.wimQuickBuy = {
  init: initializeQuickBuy,
  
  // Función para forzar la aparición del selector
  forceShowSelector: function(handle) {
    const sections = document.querySelectorAll('.wim-quickbuy-section');
    
    let targetSection = null;
    if (handle) {
      targetSection = document.querySelector(`.wim-quickbuy-section[data-original-product-card="${handle}"]`);
    } else if (sections.length > 0) {
      targetSection = sections[0];
    }
    
    if (targetSection) {
      document.body.classList.add('quickbuy-open');
      targetSection.style.bottom = "0";
      targetSection.style.opacity = "1";
      targetSection.style.visibility = "visible";
      targetSection.style.display = "block";
      targetSection.style.pointerEvents = "auto";
      return true;
    } else {
      console.error('No se encontró ningún selector para mostrar');
      return false;
    }
  },
  
  // Cerrar todos los selectores abiertos
  closeAll: function() {
    closeActiveQuickBuy();
    document.body.classList.remove('quickbuy-open');
    
    const openSections = document.querySelectorAll('.wim-quickbuy-section[style*="bottom: 0"]');
    openSections.forEach(section => {
      section.style.bottom = "-100%";
      section.style.pointerEvents = "none";
    });
    
    return true;
  }
};
